import classNames from 'classnames'
import { useScene } from 'providers/SceneProvider'
import { FC, useState } from 'react'

import Button from 'base-components/Button'
import Modal from 'base-components/Modal'
import SlideItemData from 'components/SlideItemData'
import { getSlides } from 'utils/getData'
import PartSelectorDisplay from './PartSelectorDisplay'

interface Props {}

const PartSelectorBottom: FC<Props> = () => {
  const { selectedSlide, selectNextSlide, selectPreviousSlide, partSelectorDirection: direction, deselectSlide } = useScene()
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const handleCloseModal = () => setModalOpen(false)
  const handleOpenModal = () => setModalOpen(true)
  const slideIds = getSlides().map((slide) => slide.id)
  const partIndex = selectedSlide ? slideIds.indexOf(selectedSlide.id) : 0
  const backgroundClass = 'bg-white'

  return (
    <div className='flex absolute z-50 bottom-0 text-white w-full m-2 select-none justify-center pb-2 md:pb-14 pointer-events-none'>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <SlideItemData slide={selectedSlide} id={'modalGallery'} />
        <button
          className='bg-white ml-2 p-2 mb-4 px-4 rounded-xl border-[1px] shadow-lg border-gray-800 text-gray-800 uppercase text-sm font-semibold'
          onClick={handleCloseModal}
        >
          Stäng
        </button>
      </Modal>
      <div className='pointer-events-auto flex flex-col'>
        <div className='relative flex flex-row  justify-center items-center'>
          <div className='flex flex-col justify-center items-start'>
            <div
              className={classNames(
                'flex rounded-xl border-[1px] shadow-lg bg-white border-gray-800 p-2 justify-center items-center cursor-pointer',
                backgroundClass
              )}
              onClick={selectPreviousSlide}
            >
              <svg
                aria-hidden='true'
                className='w-5 h-5 text-gray-800'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M15 19l-7-7 7-7'></path>
              </svg>
            </div>
          </div>
          <div className='flex-col mx-0'>
            <div
              className={classNames(
                'p-2 mx-2 my-2 rounded-xl border-[1px] shadow-lg bg-white border-gray-800 w-[260px] md:w-[280px] h-10 overflow-hidden pointer-events-none flex flex-row justify-center items-center',
                backgroundClass
              )}
            >
              <PartSelectorDisplay
                slideDirection='horizontal'
                page={partIndex}
                direction={direction}
                showDescription={false}
                className='flex flex-row justify-center items-center'
              />
            </div>
          </div>
          <div className='flex flex-col justify-center items-start'>
            <div
              className={classNames(
                'flex rounded-xl border-[1px] shadow-lg bg-white border-gray-800 p-2 justify-center items-center cursor-pointer',
                backgroundClass
              )}
              onClick={selectNextSlide}
            >
              <svg
                aria-hidden='true'
                className='w-5 h-5 text-gray-800'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M9 5l7 7-7 7'></path>
              </svg>
            </div>
          </div>
          {selectedSlide.id !== 'norrköping' && (
            <div className='absolute -right-12'>
              <div className=' flex flex-col justify-center items-start'>
                <div
                  className={classNames(
                    'ml-2 rounded-full border-[1px] shadow-lg bg-white border-gray-800 text-gray-800  w-[40px] h-[40px] text-[26px] p-2 justify-center items-center cursor-pointer  md:flex hidden',
                    backgroundClass
                  )}
                  onClick={deselectSlide}
                >
                  ×
                </div>
              </div>
            </div>
          )}
        </div>
        {selectedSlide.id !== 'norrköping' && (
          <div className='flex flex-row w-full justify-between  md:hidden'>
            <Button onClick={handleOpenModal}>Visa mer</Button>
            <Button onClick={deselectSlide}>Avmarkera</Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default PartSelectorBottom
